import React from "react"

/** Kill focus ring and freeze hover/active to the resting button colors. */
const TOGGLE_BTN_STYLE = {
    ["--bs-btn-focus-box-shadow"]: "none",
    ["--bs-btn-hover-bg"]: "var(--bs-btn-bg)",
    ["--bs-btn-hover-border-color"]: "var(--bs-btn-border-color)",
    ["--bs-btn-hover-color"]: "var(--bs-btn-color)",
    ["--bs-btn-active-bg"]: "var(--bs-btn-bg)",
    ["--bs-btn-active-border-color"]: "var(--bs-btn-border-color)",
    ["--bs-btn-active-color"]: "var(--bs-btn-color)",
    boxShadow: "none",
    outline: "none",
}

/**
 * Attention prompt with an inline Yes | No toggle after the question.
 * Uses Bootstrap warning-subtle tokens (same family as v2 admin notices).
 * @param {{
 *   id: string,
 *   message: string,
 *   checked: boolean,
 *   onCheckedChange: (checked: boolean) => void,
 *   className?: string,
 * }} props
 */
export default function CustomerChoicePrompt({
    id,
    message,
    checked,
    onCheckedChange,
    className = "",
}) {
    const yesId = `${id}-yes`
    const noId = `${id}-no`
    const isYes = Boolean(checked)

    return (
        <div
            className={`rounded border border-warning-subtle bg-warning-subtle px-3 py-3 ${className}`.trim()}
            role="group"
            aria-labelledby={`${id}-label`}
        >
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <div
                    id={`${id}-label`}
                    className="fw-semibold text-warning-emphasis"
                    style={{ fontSize: "1rem" }}
                >
                    {message}
                </div>
                <div
                    className="btn-group btn-group-sm ms-auto"
                    role="group"
                    aria-label="Yes or No"
                >
                    <button
                        id={yesId}
                        type="button"
                        className={
                            isYes ?
                                "btn btn-success fw-semibold" :
                                "btn btn-outline-secondary fw-semibold"
                        }
                        style={TOGGLE_BTN_STYLE}
                        aria-pressed={isYes}
                        onClick={() => onCheckedChange(true)}
                    >
                        Yes
                    </button>
                    <button
                        id={noId}
                        type="button"
                        className={
                            !isYes ?
                                "btn btn-secondary fw-semibold" :
                                "btn btn-outline-secondary fw-semibold"
                        }
                        style={TOGGLE_BTN_STYLE}
                        aria-pressed={!isYes}
                        onClick={() => onCheckedChange(false)}
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    )
}
